export default "__VITE_ASSET__CFWyAHA0__"